window.onload = () => {
	console.log("onload!~");
	// prettier-ignore
	const galleries = Array.from(document.getElementsByClassName("wp-block-blockylicious-piccy-gallery"));

	galleries.forEach((gallery) => {
		// Grab the images [list of thumbnails] and convert into array
		const thumbnails = Array.from(gallery.getElementsByClassName("thumb"));

		if (thumbnails?.[0]) {
			thumbnails[0].classList.add("selected");

			const imagePreview = Array.from(
				gallery.getElementsByClassName("image-preview"),
			); // a list needs [0]
			imagePreview[0].src = thumbnails[0].dataset.largeSize; // need camelcase (js converts it into camelcase)
		}

		thumbnails.forEach((thumbnail) => {
			thumbnail.addEventListener("click", () => {
				const selected = Array.from(
					gallery.getElementsByClassName("thumb selected"),
				);
				selected.forEach((image) => {
					image.classList.remove("selected");
				});

				thumbnail.classList.add("selected");
				const imagePreview = Array.from(
					gallery.getElementsByClassName("image-preview"),
				); // a list needs [0]
				imagePreview[0].src = thumbnail.dataset.largeSize;
			});
		});
	});
};
